import React from 'react';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';
import { useNavigate } from 'react-router-dom';

const systemImport = (name: string): Promise<any> =>
    (window as any).System.import(name);

const AppointmentsParcel: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Parcel
            config={() => systemImport('@Smalljoys/PatientAppointments')}
            mountParcel={mountRootParcel}
            onPatientSelect={(patientId: string) => navigate(`/patients/${patientId}`)}
            onLogout={() => navigate('/adminLoginV2')}
        />
    );
};

export default AppointmentsParcel;